import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  ElementRef,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalValidators } from '../../../app/utils/validators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pin-enter-screen',
  templateUrl: './pin-enter-screen.component.html',
  styleUrls: ['./set-pin.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PinEnterScreenComponent implements OnInit {
  @Output() returnPin = new EventEmitter<string>();
  @ViewChildren('pinInput') pinInputs!: QueryList<ElementRef<HTMLInputElement>>;
  @Input() currentUser;
  @Input() mfa;
  enterPinFG: FormGroup;

  pinMismatchError;
  weakPin = false;

  constructor(private fb: FormBuilder, private cdRef: ChangeDetectorRef, private router: Router, public translate: TranslateService) { }

  ngOnInit(): void {
    console.log(this.mfa);
    this.bindForm();
    this.enterPinFG.valueChanges.subscribe((v) => {
      this.weakPin = false;
      this.cdRef.detectChanges();
    });
  }

  bindForm() {
    this.enterPinFG = this.fb.group({
      pinCode: new FormGroup({
        pin1: new FormControl('', GlobalValidators.required),
        pin2: new FormControl('', [GlobalValidators.required]),
        pin3: new FormControl('', [GlobalValidators.required]),
        pin4: new FormControl('', [GlobalValidators.required]),
        // pin5: new FormControl('', [GlobalValidators.required]),
        // pin6: new FormControl('', [GlobalValidators.required]),
      }),
      confirmPinCode: new FormGroup({
        pin1: new FormControl('', GlobalValidators.required),
        pin2: new FormControl('', [GlobalValidators.required]),
        pin3: new FormControl('', [GlobalValidators.required]),
        pin4: new FormControl('', [GlobalValidators.required]),
        // pin5: new FormControl('', [GlobalValidators.required]),
        // pin6: new FormControl('', [GlobalValidators.required]),
      }),
    });

    if (!this.mfa) {
      (this.enterPinFG.get('pinCode') as FormGroup).addControl('pin5', new FormControl('', [GlobalValidators.required]));
      (this.enterPinFG.get('pinCode') as FormGroup).addControl('pin6', new FormControl('', [GlobalValidators.required]));
      (this.enterPinFG.get('confirmPinCode') as FormGroup).addControl('pin5', new FormControl('', [GlobalValidators.required]));
      (this.enterPinFG.get('confirmPinCode') as FormGroup).addControl('pin6', new FormControl('', [GlobalValidators.required]));
    }

    this.enterPinFG.valueChanges.subscribe((val) => {
      this.pinMismatchError = false;
    });
    this.cdRef.detectChanges();
    this.pinInputs.first.nativeElement.focus();
  }

  validatePin(values) {
    const pinCode = values['pinCode'] ? this.getCode(values['pinCode']) : '';
    const confirmPinCode = values['confirmPinCode'] ? this.getCode(values['confirmPinCode']) : '';
    if (pinCode && confirmPinCode && pinCode === confirmPinCode) {
      this.pinMismatchError = false;
      return true;
    }
    this.pinMismatchError = true;
    return null;
  }

  getCode = (value) => {
    let pinCode = '';
    ['pin1', 'pin2', 'pin3', 'pin4', 'pin5', 'pin6'].map((field) => {
      pinCode = pinCode + (value[field] ? value[field]?.toString() : '');
    });
    return pinCode;
  };

  // async navigateToNext(e, nextTab?, backTab?) {
  //   // console.log(e.key, e.keyCode);
  //   if (e.keyCode === 16 || e.keyCode === 46 || e.keyCode === 9) return '';
  //
  //   if ((e.keyCode === 37 || e.keyCode === 8) && backTab) $('[tabindex=' + backTab + ']').focus();
  //   else if (
  //     nextTab &&
  //     ((e.keyCode >= 48 && e.keyCode <= 57) ||
  //       (e.keyCode >= 65 && e.keyCode <= 90) ||
  //       (e.keyCode >= 96 && e.keyCode <= 105) ||
  //       e.keyCode === 39)
  //   ) {
  //     $('[tabindex=' + nextTab + ']').focus();
  //   }
  // }

  validatePINByReg(value) {
    const pinValue = value;
    let invalidPatterns = [];
    if (!this.mfa) {
      invalidPatterns = ['111111', '222222', '333333', '444444', '555555', '666666', '777777', '888888', '999999', '123456'];
    } else {
      invalidPatterns = ['1111', '2222', '3333', '4444', '5555', '6666', '7777', '8888', '9999', '1234'];
    }
    const isInvalidPattern = invalidPatterns.includes(pinValue);
    return isInvalidPattern ? { invalidPattern: true } : null;
  }

  restrictInput(event: KeyboardEvent, index): void {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight'];
    // Allow navigation and editing keys
    if (allowedKeys.includes(event.key)) {
      let pos = index;
      if (event.keyCode === 8 || event.keyCode === 37) {
        if (event.keyCode === 8 && this.pinInputs.get(index).nativeElement.value) {
          pos = index;
        } else {
          pos = index - 1;
        }
      } else {
        pos = index + 1;
      }
      if (pos > -1 && pos < 12) {
        const valueLength = this.pinInputs.get(pos).nativeElement.value.length;
        this.pinInputs.get(pos).nativeElement.setSelectionRange(valueLength, valueLength);
        this.pinInputs.get(pos).nativeElement.focus();
      }
      return;
    }

    // Allow numeric input (0-9)
    if (/^[0-9]$/.test(event.key)) {
      return;
    }

    // Prevent any other key
    event.preventDefault();
  }

  // restrictInput(event: KeyboardEvent): void {
  //   const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
  //   if (
  //     allowedKeys.indexOf(event.key) === -1 &&
  //     !/^[0-9]$/.test(event.key)
  //   ) {
  //     event.preventDefault();
  //   }
  // }

  blockPaste(event: ClipboardEvent): void {
    event.preventDefault();
  }

  async validateInput(event, index, formGroup: string, formControl: string) {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9]/g, '');
    if (
      this.enterPinFG.get(formGroup).get(formControl).value &&
      inputElement.value &&
      this.enterPinFG.get(formGroup).get(formControl).value === inputElement.value
    ) {
      let pos = index;
      if (event.keyCode === 8 || event.keyCode === 37) {
        pos = index - 1;
      } else {
        pos = index + 1;
      }
      if (pos > -1 && pos < this.pinInputs.length) {
        console.log(pos);
        this.pinInputs.get(pos).nativeElement.focus();
      }
    }
  }

  // keyUpEvent(event: KeyboardEvent, index, formGroup: string, formControl: string) {
  //   const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
  //   if (!this.enterPinFG.get(formGroup).get(formControl).value && allowedKeys.indexOf(event.key) === -1) {
  //     return;
  //   }
  //   let pos = index;
  //   if (event.keyCode === 8 || event.keyCode === 37) {
  //     pos = index - 1 ;
  //   } else {
  //     pos = index + 1 ;
  //   }
  //   if (pos > -1 && pos < 12 ) {
  //     this.rows._results[pos].nativeElement.focus();
  //   }
  // }

  enterPin = async (form) => {
    // console.log(this.validatePin(form.value), form.invalid);
    if (form.invalid || !this.validatePin(form.value)) return;
    // this.sendOtp();
    const pinCode = this.enterPinFG.value['pinCode'] ? this.getCode(this.enterPinFG.value['pinCode']) : '';
    // console.log(pinCode)
    let weakPINValidation = this.validatePINByReg(pinCode);
    // console.log(weakPINValidation)

    if (weakPINValidation) {
      this.weakPin = true;
      this.cdRef.detectChanges();
      return;
    }
    this.returnPin.emit(pinCode);
  };

  setupLater() {
    this.router.navigate(['/signin']);
  }
}
